const loadStaticPagesModule = (() => {
  const init = () => {
    const path = window.location.pathname;
    if (path.includes('/privacypolicy') || path.includes('/terms-and-conditions')) {
      const filePath = '/dist/custom/js/data/html/' +
        (path.includes('/privacypolicy')
          ? 'privacypolicy-' + getLanguage() + '.html'
          : 'terms-' + getLanguage() + '.html');

      fetch(filePath)
        .then(res => res.ok ? res.text() : Promise.reject('Failed to load content'))
        .then(html => {
          document.getElementById('inline-content').innerHTML = html;
        })
        .catch(err => {
          console.log('Error is:', err);
          document.getElementById('inline-content').innerHTML = '<p>Error loading content.</p>';
        });
    }
  };

  return { init };
})();

export default loadStaticPagesModule;
